import styled, { css } from 'styled-components'
import ripple from '../../../styles/animations/ripple'

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
`

export const ButtonPage = styled.button<{ selected: boolean }>`
  border: none;
  width: 25px;
  height: 25px;
  cursor: pointer;
  border-radius: 100px;
  color: ${({ theme }) => theme.colors.primary};
  ${({ selected, theme }) =>
    selected &&
    css`
      background-color: ${theme.colors.primary};
      color: #fff;
    `}
`

export const ButtonIcon = styled.button`
  ${ripple}
  border: none;
  background-color: transparent;
  cursor: pointer;
  svg {
    ${({ disabled }) =>
      disabled &&
      css`
        opacity: 0.5;
      `}
  }
`
